/* eslint-disable global-require */
import ModelTypeConstants from 'constants/ModelTypeConstants';
import VersionedItemSubstore from 'notebook/store/VersionedItemSubstore';
import APIUtil from 'util/APIUtil';

export const NO_VERSIONS_FOR_MODELS = null;

function getStoreForModel(apiId: string): VersionedItemSubstore | null {
  // TODO(BNCH-78973) - Make this an assertAndContinue
  if (!apiId) {
    return null;
  }
  const modelType = APIUtil.apiIdToMaybeType(apiId, true);
  switch (modelType) {
    case ModelTypeConstants.ENTRY:
      return require('stores/EntryStore').default;
    case ModelTypeConstants.STAGE_ENTRY:
      return require('workflows/stage-entries/StageEntryStore').default;
    case ModelTypeConstants.TEMPLATE:
      return require('notebook/entry-templates/TemplateStore').default;
    case ModelTypeConstants.SUBTEMPLATE:
      return require('notebook/entry-templates/SubtemplateStore').default;
    case ModelTypeConstants.PROTOCOL:
      return require('notebook/protocols/stores/EditorStore').default;
    case ModelTypeConstants.DOCUMENT:
      return require('notebook/documents/DocumentStore').default;
    default:
      return null;
  }
}

export default function getOpenVersionForClass(owningEntityApiId: string): number | null {
  const store = getStoreForModel(owningEntityApiId);
  return store ? store.getEditorState(owningEntityApiId).openVersionId : NO_VERSIONS_FOR_MODELS;
}

export function getIsLatestForClass(owningEntityApiId: string): boolean {
  return getStoreForModel(owningEntityApiId)?.getVersionState(owningEntityApiId)?.isLatest ?? false;
}
